import React from 'react';
import { connect } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { REPORT_TYPE_SET } from '../../../../config/ReportOptionSet';

const QueryTypeIcon = (props) => {
  switch (props.query_type) {
    case "BASIC":{
      return(
        <span className="type_basic">
          {props.query_type}
        </span>
      )
    }
    case "BOOLEAN":{
      return(
        <span className="type_bool">
        {props.query_type}
      </span>
      )
    }
    default:
      return null;
  }
}

const ReportTypeIcon = (props) => {
  switch (props.report_type) {
    case "volume":{
      return(
        <span className="type_volu">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "sentiment":{
      return(
        <span className="type_sent">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "source":{
      return(
        <span className="type_sour">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "relation":{
      return(
        <span className="type_wordcloud">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "category":{
      return(
        <span className="type_cate">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "positioningmap":{
      return(
        <span className="type_positioning">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "buzzlist":{
      return(
        <span className="type_buzzlist">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    default:
      return null;
  }
}

const toJavaScriptString = (jsonString) => {
  var result = jsonString.replace(/\\n/g, "\\n")  
                          .replace(/\\'/g, "\\'")
                          .replace(/\\"/g, '\\"')
                          .replace(/\\&/g, "\\&")
                          .replace(/\\r/g, "\\r")
                          .replace(/\\t/g, "\\t")
                          .replace(/\\b/g, "\\b")
                          .replace(/\\f/g, "\\f")
                          .replace(/\\\\/g, "\\\\");

  result = result.replace(/[\u0000-\u0019]+/g, "");
  return result;
}

const DropdownQRSInfo = (props) => {
  const QRSInfoContent = ({type, name, content}) => {
    switch(type){
      case 'BOOLEAN':
        return(
          <>
            <span style={{fontWeight:"bold"}}>{name}</span>&nbsp;&nbsp;&nbsp;<QueryTypeIcon query_type={type} /><br /><br />
              {JSON.parse(toJavaScriptString(props.content)).boolQuery}
          </>
        )
      case 'BASIC':
        return(
          <>
            <span style={{fontWeight:"bold"}}>{name}</span>&nbsp;&nbsp;&nbsp;<QueryTypeIcon query_type={type} /><br /><br />
              <span style={{fontWeight:"bold"}}>and</span><br />{JSON.parse(toJavaScriptString(props.content)).and.join(', ')}<br />
              <span style={{fontWeight:"bold"}}>or</span><br />{JSON.parse(toJavaScriptString(props.content)).or.join(', ')}<br />
              <span style={{fontWeight:"bold"}}>not</span><br />{JSON.parse(toJavaScriptString(props.content)).not.join(', ')}<br />
          </>
        )
      default:
        return(<></>)
    }
  }

  return (
    <OverlayTrigger
      trigger="click"
      key="left"
      rootClose={true}
      placement="left"
      overlay={
        <Popover id="popover-positioned-left">
          <Popover.Content>
            <div className="user-dropdown-menu">
              <QRSInfoContent type={props.type} name={props.name} content={props.content}/>
            </div>
          </Popover.Content>
        </Popover>
      }
      >
      <a>{props.name}</a>
    </OverlayTrigger>
  )
}

export default DropdownQRSInfo;